import React from "react";

function article_1() {
	return {
		date: "7 July 2023",
		title: "Supervised Learning and Anomaly Detection of Large-scale Imaging Data for Drug Discovery",
		description:
			"I developed a new profiling method for drug discovery with a complete data analysis pipeline. I introduced machine learning to analyze 100GB data, which achieved drug mechanism prediction with high accuracy (over 99%). I further designed a new algorthim using anomaly detection to discover novel drug candidates. The manuscript is now under review in a top academic journal Nature Methods.",
		keywords: [
			"Xinwen",
			"Xinwen Liu",
			"supervised learning",
			"anomaly detection",
			"drug discovery"
		],
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					width: 400px;
					height: 400px;
				}
				`,
		body: (
			<React.Fragment>
				<div className="article-content">
					<img
						src="../project1.png"
						alt="random"
						className="randImage"
					/>
					<div className="paragraph">
In this work, I developed a new image-based profiling method for drug discovery, which has advantages of high throughput, high content (hundreds of features) and low cost. I performed all the drug screening wet-lab experiments and imaging with a collection of more than 20,000 single-cell drug response data from different drug treatments. I further built a complete data analysis pipeline for this project, integrating cell instance segmentation, machine learning, anomaly detection and data analysis. Utilizing machine learning, it successfully predicted drug mechanism of action (MoA) with high accuracy (over 99%) at single-cell level and minimal batch effects. I further designed an algorithm integrating machine learning and anomaly detection to discover novel drug candidates. Additionally, drug-induced cell subpopulations were identified in certain drug treatments using statistical analysis, which is valuable for accessing drug resistance. Overall, this method has demonstrated great potential across multiple key areas of phenotypic screening, establishing it as a promising approach for advancing drug discovery.					</div>
					</div>
					<br/>
					<div className="paragraph">
	Columbia university has filed a provisional patent application based on this work. Due to the patent application restrictions, this work details can’t be disclosed at this moment.
					</div>
			</React.Fragment>
		),
	};
}


const myArticles = [article_1];

export default myArticles;
